import React from "react";
import { Formik, Form } from "formik";
import { IconTextInput } from "../../../../forms/components";
import {
	CreateUserSchema,
	ResetPasswordSchema,
} from "../../../../forms/schema";
import DataTable from "../../../../components/DataTable";

import {
	createUser,
	addUsers,
	resendSetup,
	removeUser,
	removePendingUser,
	resetUserPassword,
} from "../../../../libs/functions";

import Swal from "sweetalert2";
import Util from "../../../../libs/util";

class ManageMerchantUsers extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			targetUser: undefined,
		};
	}

	openResetModal = (user) => {
		this.setState({ targetUser: user });
		Util.showModal("reset-password").then(() => {});
	};

	handleSubmit = (values, { setSubmitting, resetForm }) => {
		const { merchant } = this.props;
		Swal.fire({
			title: "Creating User",
			onBeforeOpen: () => {
				Util.hideModal("create-user").then(() => {
					resetForm();
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					let status = await createUser({ ...values, merchant: merchant.id });
					if (status) {
						setSubmitting(false);
						Swal.fire({
							icon: "success",
							title: "User Created",
							onClose: () => {
								this.props.retrieveMerchants(true, true);
							},
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response) {
						if (err.response.status === 401) {
							Util.expireSession().then(() => {
								window.location = "/login";
							});
						} else {
							Swal.fire({
								icon: "error",
								title: `Unable to Create user`,
							});
						}
					}
				}
			},
		});
	};

	handleReset = (values, { setSubmitting, resetForm }) => {
		const { targetUser } = this.state;
		Swal.fire({
			title: "Resetting User Password",
			onBeforeOpen: () => {
				Util.hideModal("reset-password").then(() => {
					resetForm();
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					let status = await resetUserPassword({
						...values,
						user: targetUser._id,
					});
					if (status) {
						setSubmitting(false);
						Swal.fire({
							icon: "success",
							title: "User Password Resetted",
							onClose: () => {
								this.props.retrieveMerchants(true, true);
							},
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response) {
						if (err.response.status === 401) {
							Util.expireSession().then(() => {
								window.location = "/login";
							});
						} else {
							Swal.fire({
								icon: "error",
								title: `Unable to Reset User Password`,
							});
						}
					}
				}
			},
		});
	};

	inviteUser = () => {
		const { merchant } = this.props;
		Swal.fire({
			title: `Add User to ${merchant.name}`,
			text: `Separate multiple emails with ';'`,
			input: "text",
			inputAttributes: {
				placeholder: "account@email.com",
				autocapitalize: "off",
			},
			showCancelButton: true,
			confirmButtonText: "Add",
			showLoaderOnConfirm: true,
			allowOutsideClick: () => !Swal.isLoading(),
			preConfirm: (email) => {
				return addUsers(email.split(";"), merchant.id)
					.then((result) => {
						return result;
					})
					.catch((err) => {
						if (err.response.status === 401) {
							Util.expireSession().then(() => {
								window.location = "/login";
							});
						} else {
							Swal.fire({
								icon: "error",
								title: `Unable to Create Merchant`,
								onClose: () => {},
							});
						}
					});
			},
		}).then((result) => {
			if (result.value) {
				let { pendingUsers, existingUsers } = result.value;

				let responseAlerts = [];

				if (pendingUsers.length > 0) {
					responseAlerts.push({
						icon: "info",
						title: "Pending Users",
						text: `Setup email sent to ${pendingUsers.join(",")}`,
					});
				}

				if (existingUsers.length > 0) {
					responseAlerts.push({
						icon: "error",
						title: "Unable to add Users",
						text: `Account already exist for ${existingUsers.join(",")}`,
					});
				}

				Swal.mixin({
					confirmButtonText: responseAlerts > 1 ? "Next &rarr;" : "Confirm",
				})
					.queue(responseAlerts)
					.then((result) => {
						if (result.value) {
							this.props.retrieveMerchants(true, true);
						}
					});
			}
		});
	};

	resendSetup = (email) => {
		const { merchant } = this.props;
		Swal.fire({
			title: "Resending Setup Email...",
			allowOutsideClick: false,
			allowEscapeKey: false,
			onBeforeOpen: () => {
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					let status = await resendSetup(email, merchant.id);
					if (status) {
						Swal.fire({
							icon: "success",
							title: `Email sent to ${email}`,
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unauthorised",
						});
					}
				} catch (err) {
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Resend Setup Email`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	removeUser = (userId) => {
		Util.promptConfirmation().then((result) => {
			if (result.value) {
				Swal.fire({
					title: "Removing User",
					allowOutsideClick: false,
					allowEscapeKey: false,
					onBeforeOpen: () => {
						Swal.showLoading();
					},
					onOpen: async () => {
						try {
							let status = await removeUser(userId);
							if (status) {
								Swal.fire({
									icon: "success",
									title: `User removed!`,
								}).then(() => {
									this.props.retrieveMerchants(true, true);
								});
							} else {
								Swal.fire({
									icon: "error",
									title: "Unauthorised",
								});
							}
						} catch (err) {
							console.log(err);
							if (err.response.status === 401) {
								Util.expireSession().then(() => {
									window.location = "/login";
								});
							} else {
								Swal.fire({
									icon: "error",
									title: `Unable to Remove User`,
									onClose: () => {},
								});
							}
						}
					},
				});
			}
		});
	};

	removePendingUser = (email) => {
		Util.promptConfirmation().then((result) => {
			if (result.value) {
				const { merchant } = this.props;
				Swal.fire({
					title: "Removing Pending User",
					allowOutsideClick: false,
					allowEscapeKey: false,
					onBeforeOpen: () => {
						Swal.showLoading();
					},
					onOpen: async () => {
						try {
							let status = await removePendingUser(email, merchant.id);
							if (status) {
								Swal.fire({
									icon: "success",
									title: `${email} removed!`,
								}).then(() => {
									this.props.retrieveMerchants(true, true);
								});
							} else {
								Swal.fire({
									icon: "error",
									title: "Unauthorised",
								});
							}
						} catch (err) {
							console.log(err);
							if (err.response.status === 401) {
								Util.expireSession().then(() => {
									window.location = "/login";
								});
							} else {
								Swal.fire({
									icon: "error",
									title: `Unable to Remove Pending User`,
									onClose: () => {},
								});
							}
						}
					},
				});
			}
		});
	};

	render() {
		const {
			merchant: { name, users, pendingUsers },
			readOnly,
			retrieveMerchants,
		} = this.props;

		return (
			<div>
				<div className="users uk-margin-medium-bottom">
					<h4 className="uk-margin-remove">
						<span className="uk-flex uk-flex-middle">
							<i
								className="uk-margin-small-right form-header-icon"
								uk-icon="icon: fa-solid-users; ratio: 0.9"
							/>
							Users
							{!readOnly && (
								<button
									className="uk-margin-left uk-icon-button uk-button-primary"
									uk-icon="icon: fa-solid-user-plus; ratio: 0.5"
									uk-tooltip="Create User"
									type="button"
									uk-toggle="target: #create-user"
								/>
							)}
							{/* {!readOnly && (
								<button
									className="uk-margin-small-left uk-icon-button uk-button-primary"
									uk-icon="icon: fa-solid-paper-plane; ratio: 0.5"
									uk-tooltip="Invite User"
									type="button"
									onClick={this.inviteUser}
								/>
							)} */}
							{!readOnly && (
								<button
									className="uk-margin-small-left uk-icon-button uk-button-primary"
									uk-icon="icon: fa-solid-sync-alt; ratio: 0.5"
									uk-tooltip="Refresh List"
									type="button"
									onClick={() => retrieveMerchants(true, true)}
								/>
							)}
						</span>
						<hr className="uk-margin-small-top uk-margin-small-bottom" />
					</h4>
					{users.length > 0 && (
						<DataTable
							className="uk-table uk-table-hover uk-table-striped uk-table-responsive"
							options={{ dom: "t", ordering: false }}
						>
							<thead>
								<tr>
									<th />
									<th className="uk-table-shrink">No.</th>
									<th>Username</th>
									<th>Email</th>
									<th className="uk-width-1-5">Created At</th>
									<th className="uk-width-1-5 uk-text-center">Action</th>
								</tr>
							</thead>
							<tbody>
								{users.map((user, index) => {
									return (
										<tr key={index}>
											<td className="icon-column">
												<button
													className="uk-icon-button uk-button-danger"
													uk-icon="icon: fa-solid-minus; ratio: 0.5"
													type="button"
													onClick={() => this.removeUser(user._id)}
												/>
											</td>

											<td>{index + 1}</td>
											<td>{user.username}</td>
											<td>{user.email}</td>
											<td>{Util.toDateTimeString(user.createdAt)}</td>
											<td>
												<button
													className="uk-button uk-button-small uk-button-primary uk-width-1-1 action-btn"
													type="button"
													onClick={() => this.openResetModal(user)}
												>
													<span className="uk-text-middle uk-text-bold">
														Reset Password
													</span>
												</button>
											</td>
										</tr>
									);
								})}
							</tbody>
						</DataTable>
					)}
				</div>
				{/* <div className="pending-users">
					<h4>
						<span className="uk-flex uk-flex-middle">
							<i
								className="uk-margin-small-right form-header-icon"
								uk-icon="icon: fa-solid-user-clock; ratio: 0.9"
							/>
							Pending Users
						</span>
						<hr className="uk-margin-small-top uk-margin-small-bottom" />
					</h4>
					{pendingUsers.length > 0 && (
						<DataTable
							className="uk-table uk-table-hover uk-table-striped uk-table-responsive"
							options={{ dom: "t", ordering: false }}
						>
							<thead>
								<tr>
									<th />
									<th className="uk-table-shrink">No.</th>
									<th>Email</th>
									<th className="uk-width-1-5 uk-text-center">
										<i uk-icon="icon: fa-solid-paper-plane; ratio: 0.7" />
									</th>
								</tr>
							</thead>
							<tbody>
								{pendingUsers.map((email, index) => {
									return (
										<tr key={index}>
											<td className="icon-column">
												<button
													className="uk-icon-button uk-button-danger"
													uk-icon="icon: fa-solid-minus; ratio: 0.5"
													type="button"
													onClick={() => this.removePendingUser(email)}
												/>
											</td>

											<td>{index + 1}</td>
											<td>{email}</td>
											<td className="uk-width-1-5 uk-text-center">
												<button
													className="uk-button uk-button-small uk-button-primary uk-width-1-1 action-btn"
													type="button"
													onClick={() => this.resendSetup(email)}
												>
													<span className="uk-text-middle uk-text-bold">
														Resend Email
													</span>
												</button>
											</td>
										</tr>
									);
								})}
							</tbody>
						</DataTable>
					)}
				</div> */}
				<div
					id="create-user"
					className="uk-modal-container"
					uk-modal="bg-close: false"
				>
					<div className="uk-modal-dialog uk-modal-body">
						<h2 className="uk-modal-title">Create User for {name}</h2>
						<Formik
							initialValues={CreateUserSchema.initialValues}
							validationSchema={CreateUserSchema.validation}
							onSubmit={this.handleSubmit}
						>
							{(props) => (
								<Form className="uk-form-stacked" onSubmit={props.handleSubmit}>
									<IconTextInput
										icon="user"
										label="Username"
										id="username"
										name="username"
										type="text"
										placeholder=""
									/>
									<IconTextInput
										icon="mail"
										label="Email Address"
										id="email"
										name="email"
										type="email"
										placeholder=""
									/>
									<IconTextInput
										icon="lock"
										label="Password"
										id="password"
										name="password"
										type="password"
										autoComplete="new-password"
										placeholder=""
									/>
									<IconTextInput
										icon="lock"
										label="Confirm Password"
										id="cpassword"
										name="cpassword"
										type="password"
										autoComplete="new-password"
										placeholder=""
									/>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default"
											type="button"
											onClick={() => {
												props.resetForm();
												Util.hideModal("create-user").then(() => {
													Util.showModal("manage-user").then(() => {});
												});
											}}
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Create
										</button>
									</p>
								</Form>
							)}
						</Formik>
					</div>
				</div>
				<div
					id="reset-password"
					className="uk-modal-container"
					uk-modal="false; bg-close: false"
				>
					<div className="uk-modal-dialog uk-modal-body">
						<h2 className="uk-modal-title">Reset Password</h2>
						<Formik
							initialValues={ResetPasswordSchema.initialValues}
							validationSchema={ResetPasswordSchema.validation}
							onSubmit={this.handleReset}
						>
							{(props) => (
								<Form className="uk-form-stacked" onSubmit={props.handleSubmit}>
									<IconTextInput
										icon="lock"
										label="New Password"
										id="npassword"
										name="npassword"
										type="password"
										autoComplete="new-password"
										placeholder=""
									/>
									<IconTextInput
										icon="lock"
										label="Confirm Password"
										id="rpassword"
										name="rpassword"
										type="password"
										autoComplete="new-password"
										placeholder=""
									/>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default"
											type="button"
											onClick={() => {
												props.resetForm();
												Util.hideModal("reset-password").then(() => {
													Util.showModal("manage-user").then(() => {});
												});
											}}
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Reset
										</button>
									</p>
								</Form>
							)}
						</Formik>
					</div>
				</div>
			</div>
		);
	}
}

export default ManageMerchantUsers;
